import './DownloadCard.scss'

import React from 'react'
import {ImageType, LinkType, PageData} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {Theme} from 'views/Theme'
import {
	CardContent,
	CardImage,
	CardImageOverlay,
	CardLink,
	CardText,
	CardTitle
} from 'views/ui/Card'
import {ProductImage} from '../product/ProductImage'

const styles = style('downloadcard')

export type DownloadType = {
	download_file?: LinkType
	description?: string
	image?: ImageType
	cta?: string
	product_groups?: Array<number>
	product_filters?: Array<number>
	image_blur?: boolean
} & PageData

export const DownloadCard: React.FC<DownloadType> = ({
	title,
	image,
	description,
	download_file,
	cta,
	image_blur: blur
}) => {
	if (!download_file) return null

	return (
		<div className={styles()}>
			<Link
				className={styles('imglink')}
				to={download_file?.url}
				data-filetype={getFileExtension(download_file?.title)}
			>
				<ProductImage image={image} blur={blur} />
			</Link>
			<CardContent>
				<CardTitle theme={Theme.H5} title={title} url={download_file?.url} />
				<CardText text={description} />
				{download_file?.url && (
					<CardLink
						url={download_file?.url}
						description={cta}
						className={styles('link')}
						hideIcon={true}
						data-filetype={getFileExtension(download_file?.title)}
					/>
				)}
			</CardContent>
		</div>
	)
}

function getFileExtension(filename) {
	const ext = /^.+\.([^.]+)$/.exec(filename)
	return ext == null ? '' : ext[1]
}
